import YazioLogoImg from "@/assets/yazio.png";
import { LogoImage, LogoProps } from "../LogoImage";

type Props = Omit<LogoProps, "imgSrc" | "alt">;

export const YazioLogo = (props: Props) => (
  <LogoImage imgSrc={YazioLogoImg} alt="Yazio Logo" size="navbar" {...props} />
);
